import { getPref, setPref } from '../persistentPrefs';

const STORAGE_KEY = 'vk-control-settings';

const defaults = {
  inputMode: typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform)
    ? 'trackpad'
    : 'mouse',
  // Free placement by default: a dropped card rests exactly where it was
  // dropped. Turning this on snaps every drop into its square's tidy cascade
  // instead. Purely a local render/emit preference. The rules-facing cell
  // rides every commit either way, so the two players may disagree freely.
  snapToGrid: false,
};

const listeners = new Set();

export function getControlSettings() {
  const stored = getPref(STORAGE_KEY, null);
  if (stored && typeof stored === 'object') return { ...defaults, ...stored };
  return { ...defaults };
}

export function saveControlSettings(updates) {
  const current = getControlSettings();
  const merged = { ...current, ...updates };
  setPref(STORAGE_KEY, merged);
  for (const fn of listeners) fn(merged);
  return merged;
}

export function onControlSettingsChange(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function getInputMode() {
  return getControlSettings().inputMode;
}
